import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { AppMisc } from "../../../../misc/appMisc"
import { AppUtils } from "../../../../utils/appUtils"
import { useEffect, useRef, useState } from "react"
import AHMIS, { API_URL } from "../../../../api/api"
import AddAlertMessage from "../../../../components/alert/Alert"
import { ERROR, SOMETHING_WENT_WRONG } from "../../../../utils/constants"
import { DateUtils } from "../../../../utils/dateUtils"
import styles from "./styles"
import ReactToPrint from "react-to-print"
import { Print } from "@mui/icons-material"

const HealthServiceCard = () => {
  const [healthServiceCardTableData, setHealthServiceCardTableData] = useState();
  const id = AppUtils.getUrlParam("id");
  const printComponentRef = useRef();
  const classes = styles();

  useEffect(() => {
    getTableData();
  }, []);

  const getTableData = async () => {
    try {
      const response = await AHMIS.get(
        API_URL.mulDartaaRegister + "/" + id
      );
      setHealthServiceCardTableData(response?.data.data);
    } catch (error) {
      AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
    }
  };

  return (
    <>
      <ReactToPrint
        trigger={() => (
          <Box display={"flex"} justifyContent={"flex-end"} margin={3}>
            <IconButton>
              <Print />
            </IconButton>
          </Box>
        )}
        content={() => printComponentRef.current}
      />
      {healthServiceCardTableData &&
        <Box ref={printComponentRef} className={classes.cardContainer}>
          <Typography align="end" mb={1}>{`मिति : ${AppUtils.replaceWithNepaliDigit(DateUtils.getDateFromMilliseconds(healthServiceCardTableData?.dartaaMiti))}`}</Typography>
          <TableContainer>
            <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Health Service Card">
              <TableHead classes={{ root: "align-center" }}>
                <TableRow>
                  <TableCell>मूल दर्ता नं</TableCell>
                  <TableCell>{healthServiceCardTableData?.mulDartaaNumber}</TableCell>
                  <TableCell>नाम, थर</TableCell>
                  <TableCell>जाति कोड</TableCell>
                  <TableCell>लिङ्ग</TableCell>
                  <TableCell>उमेर</TableCell>
                </TableRow>
              </TableHead>
              <TableBody classes={{ root: "align-center" }}>
                <TableRow>
                  <TableCell>ORC दर्ता नं.</TableCell>
                  <TableCell>-</TableCell>
                  <TableCell>{healthServiceCardTableData.patientFirstName} {healthServiceCardTableData.patientLastName}</TableCell>
                  <TableCell>{healthServiceCardTableData?.casteCode && AppMisc.getCasteCodeLabelWithTooltip(healthServiceCardTableData.casteCode)}</TableCell>
                  <TableCell>{AppMisc.getGenderLabel(healthServiceCardTableData.gender)}</TableCell>
                  <TableCell>{healthServiceCardTableData?.age && AppUtils.replaceWithNepaliDigit(healthServiceCardTableData.age) + " "} {healthServiceCardTableData?.ageUnit && AppMisc.getAgeUnitLabel(healthServiceCardTableData.ageUnit)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <Box mt={1.5} />
            <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Health Service Card">
              <TableHead classes={{ root: "align-center" }}>
                <TableRow>
                  <TableCell rowSpan={2}>ठेगाना</TableCell>
                  <TableCell>जिल्ला</TableCell>
                  <TableCell>नगर/गाउँपालिका</TableCell>
                  <TableCell>वडा नं.</TableCell>
                  <TableCell>सम्पर्क नम्बर</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{AppMisc.getDistrictName(healthServiceCardTableData.district)}</TableCell>
                  <TableCell>{AppMisc.getMunicipalityName(healthServiceCardTableData?.palikaName)}</TableCell>
                  <TableCell>{AppUtils.replaceWithNepaliDigit(healthServiceCardTableData?.wardNumber)}</TableCell>
                  <TableCell>{AppUtils.replaceWithNepaliDigit(healthServiceCardTableData?.phoneNumber)}</TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
        </Box>
      }
    </>
  )
}

export default HealthServiceCard
